// import { off } from "process";

export const makeEditPayload = (vehicle) => {
  // let office = null;
  // if (vehicle.officeId) {
  //   const officeIndex = officeList.findIndex(
  //     (elm) => elm.officeId === vehicle.officeId
  //   );
  //   if (officeIndex !== -1) {
  //     office = officeList[officeIndex];
  //   }
  // }
  // let cashCenter = null;
  // if (vehicle.cashCenterId) {
  //   const index = cashCentersList.findIndex(
  //     (elm) => elm.cashCenterId === vehicle.cashCenterId
  //   );
  //   if (index !== -1) {
  //     cashCenter = cashCentersList[index];
  //   }
  // }
  const toDateOrNull = (dateStr) => (dateStr ? new Date(dateStr) : null);
  const _payload = {
    ...vehicle,
    vehicleId: vehicle.id,
    // Parse dates cleanly
    purchaseDate: toDateOrNull(vehicle.purchaseDate),
    registrationExpiry: toDateOrNull(vehicle.registrationExpiry),
    insuranceExpiry: toDateOrNull(vehicle.insuranceExpiry),
    armouringDate: toDateOrNull(vehicle.armouringDate),
    lastFitnessDate: toDateOrNull(vehicle.lastFitnessDate),
    fitnessDueDate: toDateOrNull(vehicle.fitnessDueDate),

    // Map array (fixed a tiny typo here: vendor vs vender, kept your original keys)
    installedLocks:
      vehicle.installedLocks?.map(({ lockType, vender, lockSerilNo }) => ({
        lockType,
        vender,
        lockSerilNo,
      })) || [],
  };
  // console.log("_payload", _payload);
  return _payload;
};
